import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import styled from "styled-components"
import Toptitle from "../../components/toptitle"

const Construct = () => (
  <Layout>
    <SEO title="採用情報" />
    <div>
      <section className="mx-8 lg:mr-0 lg:ml-auto lg:w-2/3">
        <Toptitle>Recruitment</Toptitle>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h1 className="font-mincho text-3xl text-primary">採用情報</h1>
        </div>
        <div className="mt-8">
          <p className="font-gothic leading-loose">
            アートマテリアルでは製品の価値を届ける営業職とその製品の製造に携わる製造職を募集しております。
            <br />
            創業から20年、私たちは不燃建材のプロフェッショナルとして建築空間に彩りと安心を届けてきました。
            <br />
            ご注文通りの製品を提供するのはもちろん、より施工しやすい形状の提案やコストを抑える加工方法の開発など、お客様にさらなるメリットをもたらすための挑戦を絶えず続けています。経験の有無を問わず、この挑戦を共に楽しみ、未来の空間づくりをともにする仲間をお待ちしています。
          </p>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">募集職種</h2>
          <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-4">
            <Link to="/recruitment/shinsotsu" className="lg:col-span-2">
              <CardWrapper className="flex w-full flex-col lg:h-[400px]">
                <StaticImage
                  src="../../images/recruit/shinsotsu.png"
                  alt="新卒採用"
                  className="aspect-[3/2] w-full"
                />
                <div className="flex flex-grow flex-col bg-secondery px-8 pt-4 pb-6">
                  <h2 className="pt-2 pb-1 font-mincho text-xl text-neutral">
                    新卒採用
                  </h2>
                  <span className="font-mincho text-sm text-neutral"></span>
                </div>
              </CardWrapper>
            </Link>
            <Link to="/recruitment/sales">
              <CardWrapper className="mt-4 flex w-full flex-col lg:mt-0">
                <StaticImage
                  src="../../images/recruit/sale1.JPG"
                  alt="営業職の採用"
                  className="aspect-[3/2] w-full"
                />
                <div className="flex flex-grow flex-col bg-secondery px-8 pt-4 pb-6">
                  <h2 className="pt-2 pb-1 font-mincho text-xl text-neutral">
                    中途 営業職
                  </h2>
                  <span className="font-mincho text-sm text-neutral">
                    勤務地 : 東京都 新宿区
                  </span>
                </div>
              </CardWrapper>
            </Link>
            <Link to="/recruitment/manufacturer">
              <CardWrapper className="mt-4 flex w-full flex-col lg:mt-0">
                <StaticImage
                  src="../../images/recruit/manu1.jpg"
                  alt="製造職の採用"
                  className="w-full"
                />
                <div className="flex flex-grow flex-col bg-secondery py-4 px-8 pb-6">
                  <h2 className="pt-2 pb-1 font-mincho text-xl text-neutral">
                    中途 製造職
                  </h2>
                  <span className="font-mincho text-sm text-neutral">
                    勤務地 : 愛知県 豊田市
                  </span>
                </div>
              </CardWrapper>
            </Link>
          </div>
        </div>
      </section>
    </div>
  </Layout>
)

const CardWrapper = styled.div`
  @media screen and (max-width: 1023px) {
    margin-top: 0px;
  }
`

export default Construct
